export enum USER_PROFILE_INFO_DISCLOSURE_KEY {
    bookAccess = 'book-access',
    bookInvites = 'book-invites',
    mailingList = 'mailing-list',
    commentMail = 'comment-mail',
    annotations = 'annotations',
    customCursor = 'custom-cursor',
    bookmarking = 'bookmarking',
    bookInvitePending = 'book-invite-pending',
    bookInviteClaimed = 'book-invite-claimed',
}
